import CalendarSurfaceItem60 from './itemTemplates/CalendarSurfaceItem60';
import CalendarSurfaceItemBase from './itemTemplates/CalendarSurfaceItem.base';
import CalendarSurfaceItemOver60 from './itemTemplates/CalendarSurfaceItemOver60';
import CalendarSurfaceItemUnder30 from './itemTemplates/CalendarSurfaceItemUnder30';
import CalendarSurfaceItemUnder45 from './itemTemplates/CalendarSurfaceItemUnder45';
import CalendarSurfaceItemUnder60 from './itemTemplates/CalendarSurfaceItemUnder60';
import differenceInMinutes from 'owa-datetime/lib/owaDate/differenceInMinutes';
import React from 'react';
import { BaseComponent } from 'office-ui-fabric-react/lib/Utilities';
import { getStyles } from './itemTemplates/CalendarSurfaceItem.styles';
import { observer } from 'mobx-react';
import { styled } from 'office-ui-fabric-react/lib/Utilities';
import {
    CalendarSurfaceItemContentProps,
    CalendarSurfaceItemProps,
} from './itemTemplates/CalendarSurfaceItem.types';

@observer
class DefaultCalendarSurfaceItem extends BaseComponent<CalendarSurfaceItemProps, {}> {
    public render() {
        return <CalendarSurfaceItemBase onRender={this.renderContent} {...this.props} />;
    }

    private renderContent = (contentProps: CalendarSurfaceItemContentProps) => {
        const { item } = contentProps;
        let durationInMinutes = differenceInMinutes(item.End, item.Start);

        if (durationInMinutes < 30) {
            return <CalendarSurfaceItemUnder30 {...contentProps} />;
        } else if (durationInMinutes < 45) {
            return <CalendarSurfaceItemUnder45 {...contentProps} />;
        } else if (durationInMinutes < 60) {
            return <CalendarSurfaceItemUnder60 {...contentProps} />;
        } else if (durationInMinutes > 60) {
            return <CalendarSurfaceItemOver60 {...contentProps} />;
        } else {
            return <CalendarSurfaceItem60 {...contentProps} />;
        }
    };
}

const CalendarSurfaceItem = styled(DefaultCalendarSurfaceItem, getStyles);
export default CalendarSurfaceItem;
